/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file DiscographiePage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

import DefaultPage from './DefaultPage'
import TweenMax from 'TweenMax'

export default class DiscographiePage extends DefaultPage {
    constructor (router, container, context, nodeType, isHome) {
        super(router, container, context, nodeType, isHome)

        this.$body = $('body')
        this.$albums = this.$cont.find('.albums-item')
        this.$filtersContainer = this.$cont.find('#filters')
        this.$filters = this.$filtersContainer.find('.filters__item')

        // Bind methods
        this.onFilterSelected = this.onFilterSelected.bind(this)
    }

    init () {
        super.init()
        this.$body.addClass('discographie-page')
    }

    destroy () {
        super.destroy()
        this.$body.removeClass('discographie-page')
    }

    initEvents () {
        super.initEvents()

        this.$filters.on('click', this.onFilterSelected)
    }

    destroyEvents () {
        super.destroyEvents()

        this.$filters.off('click', this.onFilterSelected)
    }

    onFilterSelected (e) {
        // Unactive all filters
        this.$filters.removeClass('active')

        // Get new filter item
        const $newFilterElement = $(e.currentTarget)

        // Get new filter value
        const filterName = $newFilterElement.attr('data-filter')

        // Activate filter
        $newFilterElement.addClass('active')

        if (filterName === 'all') {
            this.resetAlbums()
        } else {
            TweenMax.to(this.$albums, 0.2, {
                alpha: 0,
                display: 'none',
                onComplete: () => {
                    for (let album of this.$albums) {
                        const $album = $(album)
                        const filters = $album.attr('data-filters').split(',')

                        for (let filter of filters) {
                            if (filter === filterName) {
                                TweenMax.to(album, 0.4, {
                                    alpha: 1,
                                    display: 'flex',
                                    onComplete: () => {
                                        this.updateLazyload()
                                    }
                                })

                                break
                            }
                        }
                    }
                }
            })
        }
    }

    resetAlbums () {
        TweenMax.to(this.$albums, 0.2, {
            alpha: 1,
            display: 'flex'
        })
    }
}



// WEBPACK FOOTER //
// ./webpack/js/pages/DiscographiePage.js